import { __extends, __makeTemplateObject, __decorate, __metadata, __assign as _assign } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit-element/lit-element.js';
import { ifDefined } from '../../node_modules/lit-html/directives/if-defined.js';
import { Slotify } from '../../node_modules/@eightshapes/slotify/src/slotify.js';
import customElement from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/decorators/custom-element.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { PvdSlotifyBaseComponent } from '../pvd-base-component/pvd-slotify-base-component.js';
import { StandardSize, Size } from '../pvd-utils/enums/size.js';
import { html } from '../../node_modules/lit-html/lit-html.js';
import { ScopedElementsMixin } from '../../node_modules/@open-wc/scoped-elements/src/ScopedElementsMixin.js';
import { property } from '../../node_modules/lit-element/lib/decorators.js';

var InlineAlertIconName;
(function (InlineAlertIconName) {
    InlineAlertIconName["critical"] = "alert__critical";
    InlineAlertIconName["info"] = "alert__info";
    InlineAlertIconName["success"] = "status__confirm";
    InlineAlertIconName["warning"] = "alert__warning--full-color";
})(InlineAlertIconName || (InlineAlertIconName = {}));
var InlineAlertVariant;
(function (InlineAlertVariant) {
    InlineAlertVariant["critical"] = "critical";
    InlineAlertVariant["info"] = "info";
    InlineAlertVariant["success"] = "success";
    InlineAlertVariant["warning"] = "warning";
})(InlineAlertVariant || (InlineAlertVariant = {}));
var DEFAULT_VARIANT = InlineAlertVariant.critical;
var DEFAULT_SIZE = StandardSize.medium;
var DEFAULT_ENABLE_A11Y_ATTRIBUTES = false;
/**
 * Providence Inline Alert component.
 * @see {@link https://providence.fmr.com/components/inline-alert/inline-alert.html|Inline Alert documentation}
 */
var CustomElementMixin = customElement({
    name: 'inline-alert',
    namespace: 'pvd',
});
var PvdInlineAlert = /** @class */ (function (_super) {
    __extends(PvdInlineAlert, _super);
    function PvdInlineAlert() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pvdEnableA11yAttributes = DEFAULT_ENABLE_A11Y_ATTRIBUTES;
        _this.pvdSize = DEFAULT_SIZE;
        _this.pvdVariant = DEFAULT_VARIANT;
        return _this;
        // #endregion
    }
    Object.defineProperty(PvdInlineAlert, "scopedElements", {
        get: function () {
            // $namespace-$name-$extendingComponentName
            return {
                's-slot': customElements.get('s-slot'),
                // @ts-ignore
                'pvd-scoped-icon': customElements.get(this.namespace + "-icon"),
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PvdInlineAlert.prototype, "iconName", {
        // #endregion
        // #region private methods
        get: function () {
            return InlineAlertIconName[this.pvdVariant.toLowerCase()];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PvdInlineAlert.prototype, "roleAttribute", {
        get: function () {
            if (this.pvdEnableA11yAttributes) {
                return this.pvdVariant === InlineAlertVariant.critical ? 'alert' : 'status';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PvdInlineAlert.prototype, "ariaLiveAttribute", {
        get: function () {
            if (this.pvdEnableA11yAttributes) {
                return this.pvdVariant === InlineAlertVariant.critical ? 'assertive' : 'polite';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PvdInlineAlert.prototype, "a11yText", {
        get: function () {
            return this.pvdA11yText ? this.pvdA11yText : this.pvdVariant;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PvdInlineAlert.prototype, "iconSize", {
        get: function () {
            return this.pvdSize === StandardSize.large ? Size.medium : Size.small;
        },
        enumerable: true,
        configurable: true
    });
    // #endregion
    ////////////
    // RENDER //
    ////////////
    // #region LitElement lifecycles
    PvdInlineAlert.prototype.renderAlertIcon = function () {
        return html(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      <pvd-scoped-icon pvd-name=\"", "\" pvd-size=\"", "\"></pvd-scoped-icon>\n    "], ["\n      <pvd-scoped-icon pvd-name=\"", "\" pvd-size=\"", "\"></pvd-scoped-icon>\n    "])), this.iconName, this.iconSize);
    };
    PvdInlineAlert.prototype.render = function () {
        var classMap = {
            // @ts-ignore
            default: this.constructor.namespace + "-inline-alert-root",
            modifierPrefix: 'pvd-inline-alert',
            modifiers: [
                {
                    condition: true,
                    className: "" + this.pvdSize,
                },
                {
                    condition: true,
                    className: this.pvdVariant,
                },
            ],
        };
        return html(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      <div\n        id=", "\n        class=\"", "\"\n        role=\"", "\"\n        aria-live=\"", "\"\n      >\n        <div class=\"pvd-inline-alert__icon\">", "</div>\n        <div class=\"pvd-inline-alert__content\">\n          <span class=\"pvd-inline-alert__content-a11y-text\">", "</span>\n          ", "\n          <s-slot>", "</s-slot>\n        </div>\n      </div>\n    "], ["\n      <div\n        id=", "\n        class=\"", "\"\n        role=\"", "\"\n        aria-live=\"", "\"\n      >\n        <div class=\"pvd-inline-alert__icon\">", "</div>\n        <div class=\"pvd-inline-alert__content\">\n          <span class=\"pvd-inline-alert__content-a11y-text\">", "</span>\n          ",
            "\n          <s-slot>", "</s-slot>\n        </div>\n      </div>\n    "])), ifDefined(this.pvdId), getClassName(classMap), ifDefined(this.roleAttribute), ifDefined(this.ariaLiveAttribute), this.renderAlertIcon(), this.a11yText, this.pvdTitle
            ? html(templateObject_2 || (templateObject_2 = __makeTemplateObject([" <strong class=\"pvd-alert-content__title\">", "</strong> "], [" <strong class=\"pvd-alert-content__title\">", "</strong> "])), this.pvdTitle) : '', this.pvdText);
    };
    __decorate([
        property({
            type: String,
            reflect: true,
            attribute: 'pvd-a11y-text',
        }),
        __metadata("design:type", String)
    ], PvdInlineAlert.prototype, "pvdA11yText", void 0);
    __decorate([
        property(_assign({ type: Boolean, reflect: true, attribute: 'pvd-enable-a11y-attributes' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-enable-a11y-attributes'))),
        __metadata("design:type", Boolean)
    ], PvdInlineAlert.prototype, "pvdEnableA11yAttributes", void 0);
    __decorate([
        property({ type: String, reflect: true, attribute: 'pvd-id' }),
        __metadata("design:type", String)
    ], PvdInlineAlert.prototype, "pvdId", void 0);
    __decorate([
        property(_assign({ type: String, reflect: true, attribute: 'pvd-size' }, PvdSlotifyBaseComponent.hasChanged(StandardSize))),
        __metadata("design:type", Number)
    ], PvdInlineAlert.prototype, "pvdSize", void 0);
    __decorate([
        property({ type: String, reflect: true, attribute: 'pvd-text' }),
        __metadata("design:type", String)
    ], PvdInlineAlert.prototype, "pvdText", void 0);
    __decorate([
        property({ type: String, reflect: true, attribute: 'pvd-title' }),
        __metadata("design:type", String)
    ], PvdInlineAlert.prototype, "pvdTitle", void 0);
    __decorate([
        property(_assign({ type: String, reflect: true, attribute: 'pvd-variant' }, PvdSlotifyBaseComponent.hasChanged(InlineAlertVariant))),
        __metadata("design:type", String)
    ], PvdInlineAlert.prototype, "pvdVariant", void 0);
    return PvdInlineAlert;
}(CustomElementMixin(ScopedElementsMixin(Slotify(PvdSlotifyBaseComponent)))));
var templateObject_1, templateObject_2, templateObject_3;

export { DEFAULT_ENABLE_A11Y_ATTRIBUTES, DEFAULT_SIZE, DEFAULT_VARIANT, InlineAlertIconName, InlineAlertVariant, PvdInlineAlert };
